import React from 'react';
import HorizontalStack from '../../../styles/HorizontalStack';
import StyledConfettiExplosion from './StyledConfettiExplosion';
import { ConfettiProps } from 'react-confetti-explosion';

interface AgentCreationSuccessContainerProps {
  children: React.ReactNode;
}

const AgentCreationSuccessContainer: React.FC<
  AgentCreationSuccessContainerProps
> = ({ children }) => {
  const largeProps: ConfettiProps = {
    force: 0.8,
    duration: 3000,
    particleCount: 300,
    width: 1600,
    colors: ['#041E43', '#1471BF', '#5BB4DC', '#FC027B', '#66D805'],
  };

  return (
    <>
      <StyledConfettiExplosion {...largeProps} />
      <HorizontalStack
        alignItems="stretch"
        justifyContent="space-between"
        sx={theme => ({
          width: '100%',
          maxWidth: 1280,
          margin: '0 auto',
          minHeight: 'calc(100vh - 180px)',
          gap: 24,
          padding: '24px 16px 32px',
          [theme.breakpoints.down('lg')]: {
            flexDirection: 'column',
            alignItems: 'stretch',
            minHeight: 'auto',
            gap: 20,
          },
        })}
      >
        {children}
      </HorizontalStack>
    </>
  );
};

export default AgentCreationSuccessContainer;
